var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c(
    "v-form",
    {
      on: {
        submit: function submit($event) {
          $event.preventDefault()
          return _vm.handleInstall($event)
        }
      }
    },
    [
      _c(
        "v-slide-x-transition",
        {
          attrs: {
            "hide-on-leave": ""
          }
        },
        [
          _c(
            "v-row",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: !_vm.submitting,
                  expression: "!submitting"
                }
              ]
            },
            [
              _c(
                "v-col",
                {
                  staticClass: "pb-0",
                  attrs: {
                    cols: "12",
                    md: "8"
                  }
                },
                [
                  _c(
                    "gg-input-label",
                    {
                      attrs: {
                        for: "select-app"
                      }
                    },
                    [_vm._v("Application")]
                  ),
                  _c("v-select", {
                    directives: [
                      {
                        name: "validate",
                        rawName: "v-validate",
                        value: "required",
                        expression: "'required'"
                      }
                    ],
                    attrs: {
                      loading: _vm.loadingApps || _vm.loadingAppInfo,
                      items: _vm.appsList,
                      dense: "",
                      outlined: "",
                      "return-object": "",
                      id: "select-app",
                      placeholder: "-- Select Application --",
                      "item-text": "name",
                      "data-vv-name": "application",
                      "data-vv-as": "Application",
                      "error-messages": _vm.errors.collect("application")
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "selection",
                        fn: function fn(data) {
                          return [
                            data.item && data.item.name
                              ? _c(
                                  "div",
                                  {
                                    staticClass: "select-item"
                                  },
                                  [
                                    _c("v-img", {
                                      staticClass: "mr-2 select-logo",
                                      attrs: {
                                        src: "/static/img/app-installer-icons/".concat(
                                          data.item.logo
                                        ),
                                        contain: ""
                                      }
                                    }),
                                    _c(
                                      "span",
                                      {
                                        staticClass: "select-name"
                                      },
                                      [_vm._v(_vm._s(data.item.name))]
                                    )
                                  ],
                                  1
                                )
                              : _vm._e()
                          ]
                        }
                      },
                      {
                        key: "item",
                        fn: function fn(data) {
                          return [
                            _c(
                              "div",
                              _vm._g(
                                _vm._b(
                                  {
                                    staticClass: "select-item"
                                  },
                                  "div",
                                  data.attrs,
                                  false
                                ),
                                data.on
                              ),
                              [
                                _c("v-img", {
                                  staticClass: "mr-2 select-logo",
                                  attrs: {
                                    src: "/static/img/app-installer-icons/".concat(
                                      data.item.logo
                                    ),
                                    contain: ""
                                  }
                                }),
                                _c(
                                  "span",
                                  {
                                    staticClass: "select-name"
                                  },
                                  [_vm._v(_vm._s(data.item.name))]
                                )
                              ],
                              1
                            )
                          ]
                        }
                      }
                    ]),
                    model: {
                      value: _vm.selectedApp,
                      callback: function callback($$v) {
                        _vm.selectedApp = $$v
                      },
                      expression: "selectedApp"
                    }
                  })
                ],
                1
              ),
              _c(
                "v-col",
                {
                  staticClass: "pb-0",
                  attrs: {
                    cols: "12",
                    md: "4"
                  }
                },
                [
                  _c("gg-select", {
                    directives: [
                      {
                        name: "validate",
                        rawName: "v-validate",
                        value: "required",
                        expression: "'required'"
                      }
                    ],
                    attrs: {
                      items: _vm.languages,
                      disabled: _vm.noLangsFound,
                      loading: _vm.loadingAppInfo,
                      "item-text": function itemText(item) {
                        return ""
                          .concat(item.label, " (")
                          .concat(item.value, ")")
                      },
                      "item-value": "value",
                      label: "Language",
                      "data-vv-name": "language",
                      "data-vv-as": "Language",
                      "error-messages": _vm.errors.collect("language")
                    },
                    model: {
                      value: _vm.language,
                      callback: function callback($$v) {
                        _vm.language = $$v
                      },
                      expression: "language"
                    }
                  })
                ],
                1
              ),
              _c(
                "v-scroll-y-transition",
                [
                  _vm.selectedApp
                    ? _c(
                        "v-col",
                        {
                          attrs: {
                            cols: "12"
                          }
                        },
                        [
                          _c(
                            "v-alert",
                            {
                              attrs: {
                                color: "primary",
                                outlined: ""
                              },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "prepend",
                                    fn: function fn() {
                                      return [
                                        _c("v-img", {
                                          staticClass:
                                            "mr-2 app-installer-logo",
                                          attrs: {
                                            src: "/static/img/app-installer-icons/".concat(
                                              _vm.selectedApp.logo
                                            ),
                                            contain: ""
                                          }
                                        })
                                      ]
                                    },
                                    proxy: true
                                  }
                                ],
                                null,
                                false,
                                1192451719
                              )
                            },
                            [
                              _c("span", [
                                _vm._v(_vm._s(_vm.selectedApp.description))
                              ])
                            ]
                          )
                        ],
                        1
                      )
                    : _vm._e()
                ],
                1
              ),
              _c(
                "v-col",
                {
                  staticClass: "pb-0",
                  attrs: {
                    cols: "12",
                    md: "4"
                  }
                },
                [
                  _c("gg-select", {
                    directives: [
                      {
                        name: "validate",
                        rawName: "v-validate",
                        value: "required",
                        expression: "'required'"
                      }
                    ],
                    attrs: {
                      items: _vm.protocols,
                      label: "Protocol",
                      "data-vv-name": "protocol",
                      "data-vv-as": "Protocol",
                      "error-messages": _vm.errors.collect("protocol")
                    },
                    model: {
                      value: _vm.protocol,
                      callback: function callback($$v) {
                        _vm.protocol = $$v
                      },
                      expression: "protocol"
                    }
                  })
                ],
                1
              ),
              _c(
                "v-col",
                {
                  staticClass: "pb-0",
                  attrs: {
                    cols: "12",
                    md: "8"
                  }
                },
                [
                  _c("gg-input-label", [_vm._v("Domain")]),
                  _c("domain-select", {
                    attrs: {
                      "no-label": "",
                      "hide-details": "",
                      outlined: "",
                      solo: "",
                      flat: ""
                    },
                    on: {
                      "domain-type-selected": _vm.setDomainType
                    },
                    model: {
                      value: _vm.domain,
                      callback: function callback($$v) {
                        _vm.domain = $$v
                      },
                      expression: "domain"
                    }
                  })
                ],
                1
              ),
              _c(
                "v-col",
                {
                  staticClass: "pb-0",
                  attrs: {
                    cols: "12",
                    md: "6"
                  }
                },
                [
                  _c("gg-select", {
                    attrs: {
                      items: _vm.pathItems,
                      "item-text": "text",
                      "item-value": "value",
                      label: "Installation Path"
                    },
                    model: {
                      value: _vm.subfolder,
                      callback: function callback($$v) {
                        _vm.subfolder = $$v
                      },
                      expression: "subfolder"
                    }
                  })
                ],
                1
              ),
              _c(
                "v-col",
                {
                  staticClass: "pb-0",
                  attrs: {
                    cols: "12",
                    md: "6"
                  }
                },
                [
                  _vm.subfolder
                    ? _c("gg-text-field", {
                        directives: [
                          {
                            name: "validate",
                            rawName: "v-validate",
                            value: "required|alpha_dash",
                            expression: "'required|alpha_dash'"
                          }
                        ],
                        attrs: {
                          label: "Directory",
                          placeholder: "e.g. blog",
                          "data-vv-name": "directory",
                          "data-vv-as": "Directory",
                          "error-messages": _vm.errors.collect("directory")
                        },
                        on: {
                          keyup: function keyup($event) {
                            if (
                              !$event.type.indexOf("key") &&
                              _vm._k(
                                $event.keyCode,
                                "enter",
                                13,
                                $event.key,
                                "Enter"
                              )
                            ) {
                              return null
                            }
                            $event.preventDefault()
                            return _vm.handleInstall($event)
                          }
                        },
                        model: {
                          value: _vm.path,
                          callback: function callback($$v) {
                            _vm.path = $$v
                          },
                          expression: "path"
                        }
                      })
                    : _vm._e()
                ],
                1
              ),
              _c(
                "v-col",
                {
                  staticClass: "pb-0",
                  attrs: {
                    cols: "12",
                    md: "6"
                  }
                },
                [
                  _c("gg-text-field", {
                    directives: [
                      {
                        name: "validate",
                        rawName: "v-validate",
                        value: "required|alpha_dash",
                        expression: "'required|alpha_dash'"
                      }
                    ],
                    attrs: {
                      label: "Admin Username",
                      placeholder: "e.g. admin",
                      "data-vv-name": "username",
                      "data-vv-as": "Admin Username",
                      "error-messages": _vm.errors.collect("username")
                    },
                    on: {
                      keyup: function keyup($event) {
                        if (
                          !$event.type.indexOf("key") &&
                          _vm._k(
                            $event.keyCode,
                            "enter",
                            13,
                            $event.key,
                            "Enter"
                          )
                        ) {
                          return null
                        }
                        $event.preventDefault()
                        return _vm.handleInstall($event)
                      }
                    },
                    model: {
                      value: _vm.username,
                      callback: function callback($$v) {
                        _vm.username = $$v
                      },
                      expression: "username"
                    }
                  })
                ],
                1
              ),
              _c(
                "v-col",
                {
                  staticClass: "pb-0",
                  attrs: {
                    cols: "12",
                    md: "6"
                  }
                },
                [
                  _c("compact-password", {
                    directives: [
                      {
                        name: "validate",
                        rawName: "v-validate",
                        value: "required|min:8",
                        expression: "'required|min:8'"
                      }
                    ],
                    attrs: {
                      outlined: "",
                      charset:
                        "abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMOPRSTUVWXYZ0123456789-_@!",
                      "must-include-chars": "-_@!",
                      "must-include-number": "",
                      autocomplete: "new-password",
                      label: "Admin Password",
                      "data-vv-name": "password_adm",
                      "data-vv-as": "Admin Password",
                      "error-messages": _vm.errors.collect("password_adm"),
                      "with-generator": ""
                    },
                    on: {
                      keyup: function keyup($event) {
                        if (
                          !$event.type.indexOf("key") &&
                          _vm._k(
                            $event.keyCode,
                            "enter",
                            13,
                            $event.key,
                            "Enter"
                          )
                        ) {
                          return null
                        }
                        $event.preventDefault()
                        return _vm.handleInstall($event)
                      }
                    },
                    model: {
                      value: _vm.password,
                      callback: function callback($$v) {
                        _vm.password = $$v
                      },
                      expression: "password"
                    }
                  })
                ],
                1
              ),
              _c(
                "v-col",
                {
                  staticClass: "pb-0",
                  attrs: {
                    cols: "12",
                    md: "6"
                  }
                },
                [
                  _c("gg-text-field", {
                    directives: [
                      {
                        name: "validate",
                        rawName: "v-validate",
                        value: "required|email",
                        expression: "'required|email'"
                      }
                    ],
                    attrs: {
                      label: "Admin Email",
                      name: "Admin Email",
                      "data-vv-as": "Admin Email",
                      "error-messages": _vm.errors.collect("Admin Email")
                    },
                    on: {
                      keyup: function keyup($event) {
                        if (
                          !$event.type.indexOf("key") &&
                          _vm._k(
                            $event.keyCode,
                            "enter",
                            13,
                            $event.key,
                            "Enter"
                          )
                        ) {
                          return null
                        }
                        $event.preventDefault()
                        return _vm.handleInstall($event)
                      }
                    },
                    model: {
                      value: _vm.email,
                      callback: function callback($$v) {
                        _vm.email = $$v
                      },
                      expression: "email"
                    }
                  })
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _vm.submitting ? _c("installation-progress") : _vm._e(),
      _c(
        "v-row",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: !_vm.submitting,
              expression: "!submitting"
            }
          ]
        },
        [
          _c(
            "v-col",
            {
              attrs: {
                cols: "12"
              }
            },
            [
              _c(
                "gg-btn",
                {
                  attrs: {
                    loading: _vm.submitting
                  },
                  on: {
                    click: _vm.handleInstall
                  }
                },
                [_vm._v(" Install Application ")]
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }